<template>
  <NavBar />
  <div class="zkware-landing">
    <el-main class="content">
      <div class="section">
        <section class="aboutus">
          <about-us />
        </section>
      </div>
    </el-main>
    <!-- <el-divider></el-divider> -->
    <AppFooter />
  </div>
</template>

<script>
import AboutUs from "@/components/details/AboutUs.vue";
// import HeaderMenu from "@/components/HeaderMenu.vue";
import NavBar from "@/components/NavBar.vue";
import { ElMain } from "element-plus";
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: "AboutUsView",
  components: {
    // HeaderMenu,
    NavBar,
    AboutUs,
    ElMain,
    // ElHeader,
    // ElDivider,
    AppFooter,
    // ElFooter,
  },
};
</script>
<style scoped>
.zkware-landing {
  font-family: Arial, sans-serif;
}

.zkware-logo {
  font-family: Arial, sans-serif;
  font-size: 72px;
  font-weight: bold;
  color: white;
  display: inline-block;
}

.zkware-logo-div {
  font-family: Arial, sans-serif;
  font-size: 24px;
  font-weight: bold;
  color: white;
  display: inline-block;
}

.content {
  padding-top: 60px; /* 确保内容不被固定头部遮挡 */
}

.section {
  background-color: #fff;
  border-radius: 10px;
}

.hero {
  text-align: center;
  padding: 100px 0;
  background-image: url("../assets/bak.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.powered-by {
  font-family: Arial, sans-serif;
  font-size: 24px;
  font-weight: bold;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  /* gap: 20; */
  /* height: 100px; */
}

.powered-by-img img {
  padding: 0 5%;
  width: 150px; /* 设置固定宽度 */
  height: 100px; /* 设置固定高度 */
  object-fit: contain; /* 保持图片比例，适应容器 */
}
</style>
